import { createContext,useReducer,useState } from "react";
export const ProductsContext = createContext();

export const productsReducer = (state, action) => {
    switch (action.type) {
        case "SET_PRODUCTS":
            return {
              
                products:  action.payload
            }
        case "CREATE_PRODUCT":
            return {
            
                products:  [ action.payload,...state.products]
            }
            case "UPDATE_PRODUCT":
            return {
                products: state.products.map(product => product._id === action.payload._id ? action.payload : product)
            }
       case "DELETE_PRODUCT":
        return {
            products: state.products.filter(product => product._id !== action.payload._id)
           
            }
        // case "GET_products":
        //     return {
        //         ...state,
        //         products: action.payload
        //     }
        default:
            return state;
    }
}

export const ProductsContextProvider = ({ children }) => {

    const [state, dispatch] = useReducer(productsReducer, {products:null})
    const [name, setName] = useState('')
    const [price, setPrice] = useState('')
    const [color, setColor] = useState([''])
    const [size, setSize] = useState('')
    const [stock, setStock] = useState('')
    const [url, setUrl] = useState('')
    const [category, setCategory] = useState('')
  
    
    const [error, setError] = useState(null)
    const [update, setUpdate] = useState(false)
    const [emptyFields, setEmptyFields] = useState([])

    return (
        <ProductsContext.Provider value={{...state,dispatch, name,setName, price, setPrice,
            color, setColor, size, setSize,stock, setStock,url, setUrl,
            error, setError,emptyFields, setEmptyFields,
            update, setUpdate,category, setCategory
        }}>
            {children}
        </ProductsContext.Provider>)

}